import { render, staticRenderFns } from "./SpanExibeErroInput.vue?vue&type=template&id=5c96fc7e&scoped=true"
import script from "./SpanExibeErroInput.vue?vue&type=script&lang=js"
export * from "./SpanExibeErroInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96fc7e",
  null
  
)

export default component.exports